/* unplugin-vue-components disabled */import { render } from "./MusicDetails.vue?vue&type=template&id=43f28d2f&scoped=true"
import script from "./MusicDetails.vue?vue&type=script&lang=js"
export * from "./MusicDetails.vue?vue&type=script&lang=js"

import "./MusicDetails.vue?vue&type=style&index=0&id=43f28d2f&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f28d2f"]])

export default __exports__